/* eslint-disable */
let isScriptLoaded = false;
let isScriptLoading = false;

export const loadIDValidationScript = async (secretValues: any): Promise<void> => {
  return new Promise((resolve, reject) => {
    console.log('Starting loadIDValidationScript function')
    if (isScriptLoaded) return resolve();

    if (isScriptLoading) {
      console.log('Starting isScriptLoading function', isScriptLoading)

      const interval = setInterval(() => {
        if (window.IdentityValidator) {
          clearInterval(interval);
          isScriptLoaded = true;
          resolve();
        }
      }, 100);
      return;
    }

    isScriptLoading = true;

    const script = document.createElement('script');
    script.src = secretValues?.idvsScriptTag;
    script.async = true;
    script.defer = true;

    script.onload = () => {
      console.log('Starting isScriptLoading function', isScriptLoaded)

      isScriptLoaded = true;
      resolve();
    };

    script.onerror = (err) => reject(err);
    console.log('script', script)
    document.body.appendChild(script);
  });
};